<template>
  <article class="member-signup">
    <section v-if="showForgotPassView">
      <h2>{{forgotPassTitle}}</h2>
      <div class="subtitle">{{forgotPassTagline}}</div>
    </section>
    <ns-toast success icon :show-trigger="showTrigger" :message="addToCartMessage"></ns-toast>

    <section v-if="showForgotPassView">
      <v-form ref="resetPasswordForm" v-model="resetPasswordForm" @submit.prevent>
        <div class="field-label">{{forgotPassLabel}}</div>
        <v-text-field v-model="emailAddress" autofocus type="email"></v-text-field>
        <button
          flat
          block
          class="primary-hit mb-2 fluid"
          @click="handleForgotPassword"
        >{{forgotPassBtnText}}</button>
      </v-form>
    </section>

    <section id="forgotPassConfirmation" v-if="!showForgotPassView">
      <h1>{{forgotPassConfirmTitle}}</h1>
      <div class="narrow-wrapper">
        <div id="forgotPassConfirmText" v-html="forgotPassConfirmText"></div>
        <br />
        <ns-button
          id="forgotPassConfirmBtn"
          theme="primary-hit"
          @click="returnToLogin"
        >{{forgotPassConfirmBtnText}}</ns-button>
      </div>
    </section>
  </article>
</template>

<script>
import { AuthenticationService } from "@nuskin/ns-account";
import { NsToast } from "@nuskin/design-components";

export default {
  name: "ForgotPassword",
  components: {
    NsToast
  },
  props: {
    /**
     * The text displayed on the button in the forgot password view
     */
    forgotPassBtnText: {
      type: String,
      default: "Send Reset Link"
    },
    /**
     * The text displayed after the password recovery email has been successfully sent
     */
    forgotPassConfirmBtnText: {
      type: String,
      default: "Back To Sign In Page"
    },
    /**
     * The text displayed after the password recovery email has been successfully sent
     */
    forgotPassConfirmText: {
      type: String,
      default:
        "<p>If your username exists in our system, we have sent reset password instructions to the email provided.</p> <br> <br><p>Please note this is a time sensitive email.</p>"
    },
    /**
     * The Title displayed after the password recovery email has been successfully sent
     */
    forgotPassConfirmTitle: {
      type: String,
      default: "Thank You!"
    },
    /**
     * Error message that appears if the input on the forgot password view is invalid
     */
    forgotPassError: {
      type: String,
      default: "A username or email address is required"
    },
    /**
     * Used to overide the default href that links to the forgot password view.
     * Mainly needed for use in the dev portal playground.
     */
    forgotPassHref: {
      type: String,
      default: "#forgot-password"
    },

    /**
     * The label text for the forgot password input on the forgot password view
     */
    forgotPassLabel: {
      type: String,
      default: "Username (Email Address)"
    },
    /**
     * The text for the link that takes the user from the main login view to the forgot password view
     */
    forgotPassLinkText: {
      type: String,
      default: "Forgot Password"
    },
    /**
     * The tagline text (just under the title) for the forgot password view
     */
    forgotPassTagline: {
      type: String,
      default:
        "Enter your username below and we will send you a link to reset your password."
    },
    /**
     * The title text for the forgot password view
     */
    forgotPassTitle: {
      type: String,
      default: "Forgot your password?"
    }
  },
  data() {
    return {
      showForgotPassView: true,
      dialog: true,
      dialogError: null,
      emailAddress: "",
      emailAddressForm: {},
      showTrigger: false,
      addToCartMessage: "Testing"
    };
  },
  methods: {
    returnToLogin() {
      this.showForgotPassView = true;

      this.$router.push({
        name: "login"
      });
      //     this.showTrigger = !this.showTrigger;
      /*   // Manually strip url hash before sending user back to login view
      let newUrl = new URL(window.location.href);
      newUrl.hash = "";
      if (this.route) {
        this.set("route.path", "");
      } else {
        window.location.href = newUrl.href;
      }
      this.$router.push({
        name: "login"
      });
      */
    },
    handleForgotPassword() {
      AuthenticationService.forgotPassword(
        this.emailAddress,
        window.forgotPasswordConfig
      );
      this.showForgotPassView = false;
    },
    _setTranslations() {
      this.forgotPassBtnText =
        loginTranslations.forgotPassBtnText || this.forgotPassBtnText;
      this.forgotPassConfirmBtnText =
        loginTranslations.forgotPassConfirmBtnText ||
        this.forgotPassConfirmBtnText;
      this.forgotPassConfirmText =
        loginTranslations.forgotPassConfirmText || this.forgotPassConfirmText;
      this.forgotPassConfirmTitle =
        loginTranslations.forgotPassConfirmTitle || this.forgotPassConfirmTitle;
      this.forgotPassError =
        loginTranslations.forgotPassError || this.forgotPassError;
      this.forgotPassLabel =
        loginTranslations.forgotPassLabel || this.forgotPassLabel;
      this.forgotPassLinkText =
        loginTranslations.forgotPassLinkText || this.forgotPassLinkText;
      this.forgotPassTagline =
        loginTranslations.forgotPassTagline || this.forgotPassTagline;
      this.forgotPassTitle =
        loginTranslations.forgotPassTitle || this.forgotPassTitle;
    }
  },
  mounted() {
    this._setTranslations();
    AuthenticationService.initRunConfig(window.loginPageConfig);
  }
};
</script>

<style lang="scss">
.loader {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(255, 255, 255, 0.5);
  pointer-events: none;

  .loader-container {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  img {
    height: 150px;
    width: 150px;
    align-self: center;
  }

  #forgotPassConfirmText {
    text-align: left;
    padding-top: 20px;
    padding-left: 40px;
    padding-right: 40px;
  }

  #forgotPassConfirmBtn {
    margin-left: 40px;
    margin-right: 40px;
  }
}
</style>
